<template>
<div>

<div class="vx-card__title mb-4">
                  <h4>Login</h4>
                  <p>Welcome back, please login to your account.</p>
                </div>
  <div class="login_wrap"> 


  
    <div class="alert alert-warning" v-html="error_msg" v-if="error_msg!=''"> 
      <!--{{error_msg}}-->
    </div>
    <div class="form-group" @click="error_msg!=''">
      <label class="form_label">Email</label>
      <vs-input
            v-validate="'required|email|min:3'"
            data-vv-as="Email"
            name="email"
            icon-no-border
            icon="icon icon-user"
            icon-pack="feather" 
            v-model="email"
            autocomplete="off"
            class="w-full"
            @keyup.enter="loginJWT"
            :disabled="twofactorAuth || requireInactiveCode"
    />
    <!-- <input
            v-validate="'required|email|min:3'"
            data-vv-as="Email"
            name="email"
            icon-no-border
            icon="icon icon-user"
            icon-pack="feather"
            placeholder="Email"
            v-model="email"
            autocomplete="off"
            class="w-full form_input email"
            @keyup.enter="loginJWT"
    /> -->
    <span class="text-danger text-sm">{{ errors.first("email") }}</span>
    </div>
    <div class="form-group" @click="error_msg!=''">
   
    <label class="form_label">Password</label>
    <vs-input
     data-vv-as="Password"
      v-validate="'required'"
      type="password"
      name="password"
      icon-no-border
      icon="icon icon-lock"
      icon-pack="feather" 
      v-model="password"
      :disabled="twofactorAuth || requireInactiveCode"
      autocomplete="off"
      class="w-full"
      @keyup.enter="loginJWT"
      @click="error_msg=''"
    />
    <!-- <input
     data-vv-as="Password"
      v-validate="'required'"
      type="password"
      name="password"
      icon-no-border
      icon="icon icon-lock"
      icon-pack="feather"
      placeholder="Password"
      v-model="password"
      autocomplete="off"
      class="w-full form_input password"
      @keyup.enter="loginJWT"
      @click="error_msg=''"
    /> -->
    <span class="text-danger text-sm">{{ errors.first("password") }}</span>
    </div>

<!-- <div class="form-group" @click="error_msg!=''"  v-if="requireInactiveCode"  > -->
  <div class="varification_code" v-if="requireInactiveCode">
    <div class="form-group" @click="error_msg!=''"   >
    <label class="form_label">Enter Verification Code</label>
    <vs-input
     data-vv-as="g-code"
      v-validate="'required'"
      type="text"
      name="inactive code"
      icon-no-border
      icon="icon icon-lock"
      icon-pack="feather" 
      v-model="verificationCode"
      autocomplete="off"
      class="w-full"
      @keyup.enter="loginJWT"
      @click="error_msg=''"
    />
    
    <span class="text-danger text-sm">{{ errors.first("inactive code") }}</span>
    </div>
    <label @click="verificationCode=''; requireInactiveCode =false;error_msg='' ;loginJWT()"  class="resend">Resend</label>
  </div>
    <div class="form-group" @click="error_msg!=''"  v-if="twofactorAuth" >
   
    <label class="form_label">Enter Two Factor Code</label>
    <vs-input
     data-vv-as="g-code"
      v-validate="'required'"
      type="text"
      name="g-code"
      icon-no-border
      icon="icon icon-lock"
      icon-pack="feather" 
      v-model="code"
      autocomplete="off"
      class="w-full"
      @keyup.enter="loginTwoFactor"
      @click="error_msg=''"
    />
    
    <span class="text-danger text-sm">{{ errors.first("password") }}</span>
    </div>
    <div class="flex flex-wrap justify-between my-5">
      <vs-checkbox v-model="checkbox_remember_me" class=""
        >Remember Me</vs-checkbox
      >
      
      <router-link to="/pages/forgot-twofactorauth" class="forgot">Reset Two Factor login?</router-link>
      <router-link to="/pages/forgot-password" class="forgot">Forgot Password?</router-link>
    </div>
    <div class="flex flex-wrap justify-between mb-3 align-center">
      <p class="register_text">
        If you are not already a registered customer, please
        <router-link to="register"> Register</router-link> here
      </p><!----> 
      <vs-button :disabled="!validateForm"  @click="loginJWT" v-if="!twofactorAuth">Login</vs-button>
      <vs-button v-else  :disabled="!validateMe"  @click="loginTwoFactor">Verify</vs-button>
      
    </div>

    
  </div>
</div> 
</template>

<script>
import _ from "lodash";
import cryptoJS from "crypto-js";
export default {
  data () {
    return {
      email: '',
      password: '',
      code:'',
      verificationCode:'',
      twofactorAuth:false,
      requireInactiveCode:false,
      resendVerifyCode:false,
      checkbox_remember_me: false,
      error_msg:'',
       userId: "",
       key: "",
       userDetails:null,
    }
  },
  computed: {
    validateForm () {
      return !this.errors.any() && this.email !== '' && this.password !== ''
    },
    validateMe () {
      return !this.errors.any() && this.email !== '' && this.password !== '' && this.code !== ''
    },
     activeUserInfo () { 
     
      return this.$store.state.auth.user
    },
  },
  methods: {
     get_userDetails() {
    
      const postData = {
        userId: this.userId,
        pin: this.key,
      };
     
       this.error = false;
      this.$store
        .dispatch("get_user_token_details", postData)
        .then((response) => {
          thiws.userDetails = response;
        
        })
        .catch((error) => {
        });
    },
    checkLogin () {
      // If user is already logged in notify
      if (this.$store.state.auth.isUserLoggedIn()) {
        // Close animation if passed as payload
        // this.$vs.loading.close()

        this.$vs.notify({
          title: 'Login Attempt',
          text: 'You are already logged in!',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning',
          position:"top-right"
        })

        return false
      }
      return true
    },
    loginTwoFactor(){
         // if (!this.checkLogin()) return false;
    this.error_msg ='';
      // Loading
      this.$vs.loading()
      const payload = {
        checkbox_remember_me: this.checkbox_remember_me,
        userDetails: {
          email: this.email,
          password: this.password,
          code:this.code,
          //verificationCode:this.verificationCode,
         // resendVerifyCode:this.resendVerifyCode,
          
        },
        twofactorAuth:this.twofactorAuth
      }

      this.$store
        .dispatch('auth/login', payload)
        .then((res) => {
           this.$vs.loading.close();
          this.$router.push(this.$router.currentRoute.query.to || '/')

        })
        .catch((error) => {
          this.code =''
          this.$vs.loading.close();
          this.error_msg = error;
          this.resendVerifyCode =false;
          
        })

    },
    loginJWT () {
           // if (!this.checkLogin()) return false;
    this.error_msg ='';
    this.$vs.loading()
      const payload = {
        checkbox_remember_me: this.checkbox_remember_me,
        userDetails: {
          email: this.email,
          password: this.password,
          // code:this.code,
          //inactiveVerifyCode:this.resendVerifyCode,
          //resendVerifyCode:true
          
        },
        twofactorAuth:this.twofactorAuth,
        
      }

      if(this.requireInactiveCode){
        payload['userDetails']['inactiveVerifyCode'] =  this.verificationCode;

      }
       if(this.requireInactiveCode){
        payload['userDetails']['resendVerifyCode'] =  this.resendVerifyCode;

      }


      this.$store .dispatch('auth/login', payload).then((res) => {
           this.code =''
            this.resendVerifyCode = false;
          
            
          if( _.has(res ,'code') && res['code'] == 'VERIFY_INAVTIVITY_CODE'){
           
             this.$vs.loading.close()
             this.requireInactiveCode =true;
              this.twofactorAuth = false;
          
          }else if( _.has(res ,'code') && res['code'] == 'VERIFY_2FA_CODE'){
            

             this.$vs.loading.close()
              this.twofactorAuth = true;
               this.requireInactiveCode =false;
          }else{

            
            this.requireInactiveCode =false;
            this.twofactorAuth = false;
             this.resendVerifyCode =false;
             //alert(this.$router.currentRoute.query.to);

              if (
                (this.activeUserInfo.loginRoleId ==1 &&  _.has(this.$route ,"query" ))
               && ( _.has(this.$route.query ,"userId" ) &&  this.$route.query.userId != undefined &&   this.$route.query.userId != null)
               && (  _.has(this.$route.query ,"key" ) &&  this.$route.query.key != undefined &&   this.$route.query.key != null)
              ) {
                this.userId = this.$route.query.userId;
                this.key = this.$route.query.key;
                 window.location.reload();
              //  setTimeout(()=>{
              //    alert("setTimeout")
              //     this.$emit("detailsGet" ,true)

              //  },1000)
               
                /*
                  this.$vs.notify({
                title: "Error",
                text: "sd sdjfsdf",
                position: "top-right",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                });
                */


              
              }else{
                this.$vs.loading.close()
               
                 this.$router.push(this.$router.currentRoute.query.to || '/')

             }
          

          }
         
          //  this.$router.go('/');

          
        }).catch((error) => {
        
          this.code =''
           this.$vs.loading.close()
           // this.requireInactiveCode =false;
              this.resendVerifyCode =false;
            this.twofactorAuth = false;
          this.error_msg = error;
         
        })
    
    },
    getCookie(cname) {
      var name = cname + "=";
      var decodedCookie = document.cookie;
      var ca = decodedCookie.split(';');
      for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
    registerUser () {
      if (!this.checkLogin()) return
      this.$router.push('/register').catch(() => {})
    },
    setRemember() {
      var email = this.getCookie('email')
      var decryptedPwd = this.getCookie('server_Js')
      var password = cryptoJS.AES.decrypt(decryptedPwd, "FV$HSEDEEPV@JUG").toString(cryptoJS.enc.Utf8)
      if (email) {
        this.email = email;
      }
      if (password) {
        this.password = password;
      }
      this.checkbox_remember_me = true;
    },
     getTokenDetails() {
    let payload = {
      pin:this.key,
    }
     this.$vs.loading();
      this.$store
        .dispatch("getTokenDetails", payload)
        .then((res) => {
           this.$vs.loading.close();
           //alert(res.status)
          if(!res.status){
            this.$vs.notify({
            title: "Error",
            text: "Verification token is already used",
            position: "top-right",
            iconPack: "feather",
            position: "top-right",
            icon: "icon-alert-circle",
            color: "danger",
          });
            this.$router.push(this.$router.currentRoute.query.to || '/')
          }
         
        })
        .catch((err)=>{
           this.$vs.loading.close();

            this.$vs.notify({
            title: "Error",
            text: err.error_message.message,
            position: "top-right",
            iconPack: "feather",
            position: "top-right",
            icon: "icon-alert-circle",
            color: "danger",
          });

           this.$router.push(this.$router.currentRoute.query.to || '/')

        })

  },
  },
  mounted() {
    this.userId ='';
    this.key ='';
    this.setRemember();

      if (
        ( _.has(this.$route ,"query" ))
        && ( _.has(this.$route.query ,"userId" ) &&  this.$route.query.userId != undefined &&   this.$route.query.userId != null)
        && (  _.has(this.$route.query ,"key" ) &&  this.$route.query.key != undefined &&   this.$route.query.key != null)
      ) {
        this.userId = this.$route.query.userId;
        this.key = this.$route.query.key;

        this.getTokenDetails();
      }

    
    
       
  }
}
</script>

